import { AnalyzeConstants } from '../../_constants/Analyze/analyze.constants';
import { lndSevice } from '../../_services/Analyze/lnd.service';

export const lndAction = {
    lndDataAction
}

// let wannaBlock = false;
// let timeStamp = 0;

/*
timeStamp = 0
currentTimeStamp = 1 ------ Waiting --- timestamp === 2 && currentTimeStamp = 1


timeStamp = 2
currentTimeStamp = 3 -------- Done
*/

//OrgAdmin ORG TEAM starts
function lndDataAction(data,callBack) {
    // timeStamp = new Date().getTime();
    // let currentTimeStamp = new Date().getTime();
    return dispatch => {
        dispatch(request());
        lndSevice.getLnData(data)
        //block logic
        // .then(function(value) {

        //     debugger

        //     if(currentTimeStamp <= timeStamp) {
        //         wannaBlock = true;
        //     }
            
        //     if(!wannaBlock){
        //       return Promise.resolve(value)
        //     } else {
        //       return Promise.reject(value)
        //     }
        //   }, (e) =>  {
        //      return Promise.reject(e)
        //   })

          // blok code compltes
        
            .then(
                res => {
                    // if(currentTimeStamp < timeStamp) {
                    //     wannaBlock = true;
                    // }

                    // if(!wannaBlock) {
                    //     dispatch(success(res));
                    // }

                    dispatch(success(res));



                    // wannaBlock = false
                    callBack != undefined ? callBack() : null
                },
                error => {
                    dispatch(failure(error));
                    callBack != undefined ? callBack() : null
                }
            );
    };

    function request() { return { type: AnalyzeConstants.REQUEST_LnD_DATA } }
    function success(res) { return { type: AnalyzeConstants.RECEIVE_LnD_DATA, res } }
    function failure(error) { return { type: AnalyzeConstants.ERROR_LnD_DATA, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/Analyze/lnd.action.js